import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import * as actions from './action'
import { Select, Table, Button, message, Dropdown, Menu, Tag } from 'antd'
import Popconfirm from '../../components/Popconfirm/Popconfirm2'
import { postCouponData } from '../../api/cardManage'
import { ACTIONTYPE } from './constants'
import DetailModal from './components/detailModal'
import HistoryModal from './components/historyModal'
import './style.css'

const Option = Select.Option

class CardManage extends React.Component {
  state = {
    tableLoading: false,
    confirmLoading: false,
    couponItem: null,
    showDetail: false,
    historyShow: false,
  }

  componentDidMount() {
    this.getDatas()
    this.props.fetchClubTableList()
  }

  // 获取卡券列表
  getDatas = async () => {
    this.setState({
      tableLoading: true,
    })
    await this.props.getCouponListData()
    this.setState({
      tableLoading: false,
    })
  }

  detailHandle = async (couponItem) => {
    const { actionType } = this.props
    if (actionType == ACTIONTYPE.DETAIL) {
      this.setState({ showDetail: false })
      return
    }
    if (!this.verifyData(couponItem)) {
      return
    }
    const { coupon, expiration, duration, tableIds } = couponItem
    const params = {
      ...couponItem,
      coupon: {
        ...coupon,
        id: actionType == ACTIONTYPE.ADD ? -1 : coupon.id,
        amount: !coupon.amount ? '' : coupon.amount * 100,
        limitDuration: coupon.limitDuration * 60,
        isTableLimit: !coupon.isTableLimit,
      },
      expiration,
      duration: {
        startTime: !coupon.canWholeDay ? duration.startTime : '00:00:00',
        endTime: !coupon.canWholeDay ? duration.endTime : '00:00:00',
        // isForceFinishOnEndTime: !coupon.canWholeDay
        //   ? duration.isForceFinishOnEndTime
        //   : false,
      },
      tableIds,
    }
    console.log('提交数据:', params)
    this.setState({ confirmLoading: true })
    const { data, status, detail } = await postCouponData(params)
    this.setState({ confirmLoading: false })
    if (status != 1) {
      message.error(detail)
      return
    }
    message.success('保存成功')
    this.setState({ showDetail: false })
    this.getDatas()
  }

  deleteEvent = async (item) => {
    this.props.deleteCoupon(item)
  }

  historyEvent = async (item) => {
    this.setState({
      historyShow: true,
      couponItem: item,
    })
  }

  // 选择卡券类型
  onHandleFilter = (key) => {
    this.props.updateCouponStatus(key)
  }

  // 筛选卡券显示类型
  filterList = () => {
    this.getDatas()
  }

  actionEvent = (actionType, item) => {
    this.props.updateActionType(actionType)
    this.setState({
      couponItem: item,
      showDetail: true,
    })
  }

  verifyData(couponItem) {
    const { coupon, expiration, duration, tableIds } = couponItem
    const {
      denomination,
      issue,
      name,
      canWholeDay,
      isTableLimit,
      isLimitTime,
      limitDuration,
      amount,
    } = coupon
    const { startDate, endDate } = expiration
    // const { startTime, endTime } = duration
    const startTime = duration ? duration.startTime : ''
    const endTime = duration ? duration.endTime : ''
    let showText = ''
    let pass = false
    const sDate = new Date(startDate)
    const eDate = new Date(endDate)
    if (!name) {
      showText = '请输入卡券名称!'
    } else if (!denomination) {
      showText = '输入面额需大于0!'
    } else if (!issue) {
      showText = '请输入发行数量!'
    } else if (sDate.getTime() > eDate.getTime()) {
      showText = '有效期设置的结束日期必须大于或等于开始日期!'
    } else if (!canWholeDay && (startTime.length == 0 || endTime.length == 0)) {
      showText = '请选择营业时间的开始/结束时间!'
    } else if (!isTableLimit && tableIds.length == 0) {
      showText = '请选择可以使用此券的球台!'
    } else if (isLimitTime && !limitDuration) {
      showText = '请输入每日限时使用的时间!'
    } else if (amount < 0) {
      showText = '输入售价不可小于0!'
    } else {
      showText = ''
      pass = true
    }
    if (!pass) {
      message.error(showText)
    }
    return pass
  }

  render() {
    const {
      tableLoading,
      showDetail,
      historyShow,
      couponItem,
      confirmLoading,
    } = this.state
    const { actionType, couponList, clubTables, couponStatus } = this.props
    const columns = [
      { title: '俱乐部名', dataIndex: ['club', 'name'] },
      { title: '卡券名', dataIndex: ['coupon', 'name'] },
      {
        title: '卡券类型',
        dataIndex: ['coupon', 'typeId'],
        render: (text) => {
          return +text === 1 ? '金额券' : '钟时券'
        },
      },
      {
        title: '面额',
        dataIndex: ['coupon', 'denomination'],
        render: (text, record) => {
          return +record.type_id === 1 ? `${text}元` : `${text}分钟`
        },
      },
      {
        title: '剩余数量',
        dataIndex: ['couponStock', 'remain'],
        render: (text, record) => {
          if (record.issue == 0) {
            return '不限量'
          }
          return text
        },
      },
      {
        title: '有效日期',
        dataIndex: 'date',
        render: (text, record) => {
          return `${record.expiration.startDate} - ${record.expiration.endDate}`
        },
      },
      {
        title: '操作',
        dataIndex: 'action',
        render: (text, record) => {
          const menu = () => {
            return (
              <Menu>
                <Menu.Item key="0">
                  <span
                    onClick={() => this.actionEvent(ACTIONTYPE.DETAIL, record)}
                  >
                    详情
                  </span>
                </Menu.Item>
                {couponStatus != 3 && (
                  <Menu.Item key="1">
                    <span
                      onClick={() => this.actionEvent(ACTIONTYPE.EDIT, record)}
                    >
                      修改
                    </span>
                  </Menu.Item>
                )}
                {couponStatus != 3 && (
                  <Menu.Item key="2">
                    <Popconfirm
                      title={`是否删除${record.coupon.name}此卡券?`}
                      onConfirm={() => this.deleteEvent(record)}
                      okText="确认"
                      cancelText="取消"
                    >
                      <span>删除</span>
                    </Popconfirm>
                  </Menu.Item>
                )}
              </Menu>
            )
          }
          return (
            <div>
              <Button type="primary" onClick={() => this.historyEvent(record)}>
                购买记录
              </Button>
              <Dropdown overlay={menu} trigger={['click']}>
                <Tag className="card-tag-more-view" color="#ff997a">
                  更多
                </Tag>
              </Dropdown>
            </div>
          )
        },
      },
    ]
    const filterOptions = [
      { title: '在售的卡券', id: 1 },
      { title: '已过期的卡券', id: 2 },
      { title: '已删除的卡券', id: 3 },
    ].map((item, idx) => {
      return (
        <Option key={idx} value={item.id}>
          {item.title}
        </Option>
      )
    })
    return (
      <div>
        <div className="table-header">
          <div className="club-filter">
            <Button
              type={'primary'}
              style={{ marginLeft: '20px' }}
              onClick={() => this.actionEvent(ACTIONTYPE.ADD, null)}
            >
              新建卡券
            </Button>
          </div>
          <div className="card-filter">
            <Select
              placeholder="在售卡券"
              style={{ width: 200 }}
              value={couponStatus}
              onChange={this.onHandleFilter}
            >
              {filterOptions}
            </Select>
            <Button
              type={'primary'}
              style={{ marginLeft: '10px' }}
              onClick={this.filterList}
            >
              筛选
            </Button>
          </div>
        </div>

        <Table
          rowKey={(record) => record.coupon.id}
          bordered
          columns={columns}
          loading={tableLoading}
          dataSource={couponList}
        />

        {showDetail && (
          <DetailModal
            confirmLoading={confirmLoading}
            actionType={actionType}
            couponItem={couponItem}
            clubTables={clubTables}
            onOk={this.detailHandle}
            onCancel={() => this.setState({ showDetail: false })}
          />
        )}
        {historyShow && (
          <HistoryModal
            couponItem={couponItem}
            onCancel={() => this.setState({ historyShow: false })}
          />
        )}
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    actionType: state.getCardManage.actionType,
    clubTables: state.getCardManage.clubTables,
    couponStatus: state.getCardManage.couponStatus,
    couponList: state.getCardManage.couponList,
  }
}
export default withRouter(connect(mapStateToProps, actions)(CardManage))



// WEBPACK FOOTER //
// ./src/containers/CardManage/index.js